import {
    getCurrentInstance,
} from '@vue/composition-api';
import { Store } from 'vuex';
import { createNamespacedHelpers } from '@/libs/vuexHelper';

export default function useStore() {
    const instance = getCurrentInstance();
    const store = instance?.proxy.$store as Store<any>;

    const mainModule = createNamespacedHelpers(store, 'main');
    const userModule = createNamespacedHelpers(store, 'user');
    const companyModule = createNamespacedHelpers(store, 'company/company');
    const chatModule = createNamespacedHelpers(store, 'chat');
    const passportModule = createNamespacedHelpers(store, 'user/passport');
    const profileModule = createNamespacedHelpers(store, 'user/profile');
    const emailModule = createNamespacedHelpers(store, 'email');
    const broadcastModule = createNamespacedHelpers(store, 'broadcast');
    const configModule = createNamespacedHelpers(store, 'config');
    const splitLinkModule = createNamespacedHelpers(store, 'automation/SplitLink');
    const taskModule = createNamespacedHelpers(store, 'task');
    const {
        projectId, project, roleId, channel_auth_type, projectCode, userId,
    } = userModule.useFields(['projectId', 'project', 'roleId', 'channel_auth_type', 'projectCode', 'userId']);

    return {
        store,
        mainModule,
        userModule,
        projectId,
        projectCode,
        project,
        roleId,
        channel_auth_type,
        companyModule,
        chatModule,
        passportModule,
        emailModule,
        configModule,
        profileModule,
        broadcastModule,
        splitLinkModule,
        taskModule,
        userId,
    };
}
